<template>
  <div class="container-fluid customer-profile-container">
    <b-card
      class="
        card-transparent-background card-customer-profile-container-dy
        mt-md-5 mt-1
      "
    >
      <b-row class="mt-md-3 mt-1">
        <b-col xl="3" lg="4">
          <b-card
            class="card-transparent-background card-profile-info-dy my-md-3 my-1"
            no-body
            tag="article"
          >
            <b-card-img
              v-if="profile_img != null && profile_img != ''"
              :src="profile_img"
              top="true"
            >
            </b-card-img>
            <b-avatar v-else class="profile-img-text-dy" :text="avatar_text"></b-avatar>

            <b-card-body>
              <b-card-title>{{ user_name }}</b-card-title>
              <div class="w-100 text-center mt-3">
                <!-- <b-button
                variant="cutomer-primary"
                class="w-100 btn-bumblebee btn-doomyoga btn-doom-yoga-play"
                >Edit</b-button
              > -->
                <router-link
                  to="/doom_yoga/my_profile/edit"
                  class="
                    btn
                    btn-bumblebee
                    btn-doomyoga
                    btn-cutomer-primary
                    btn-doom-yoga-play
                  "
                  >Edit</router-link
                >
              </div></b-card-body
            >
          </b-card>
        </b-col>
        <b-col xl="9" lg="8">
          <b-row>
            <b-col lg="9" class="mx-auto">
              <!-- previosly played -->
              <b-card
                class="
                  card-transparent-background card-media-container-doomyoga card-media-container-profile-doomyoga
                  mt-1
                "
                title="Previously Played"
                 body-class="p-0"
              >
                <VueSlickCarousel
                  v-bind="settings_slick"
                  class="slick-container-dy"
                >
                  <template #prevArrow>
                    <div class="custom-arrow">
                      <img src="@/assets/images/doom-yoga/arrow-left.png" />
                    </div>
                  </template>
                  <div
                    v-for="item in previously_played_list"
                    :key="item.id"
                    class=""
                  >
                    <SimpleMediaCard
                      client_name="DY"
                      :title="item.title"
                      :duration="item.duration"
                      :img_src="item.img_src"
                    />
                  </div>
                  <template #nextArrow>
                    <div class="custom-arrow">
                      <img src="@/assets/images/doom-yoga/arrow-right.png" />
                    </div>
                  </template>
                </VueSlickCarousel>
              </b-card>

              <!-- end previosly played -->

              <!-- booked classes -->
              <dataset
                :ds-data="booked_events"
                :ds-search-in="['title', 'artist', 'album']"
                :ds-search-as="{ searchTest }"
              >
                <dataset-show
                  :ds-show-entries="entries"
                  class="showEntriesSelectContainer float-right d-none"
                />
                <div class="row">
                  <div class="col-md-12">
                    <div class="row my-2">
                      <div class="col">
                        <h3 class="customer-profile-title">Bookings</h3>
                      </div>
                    </div>
                  </div>
                </div>
                <b-row>
                  <b-col>
                    <dataset-item>
                      <template #default="{ row }">
                        <b-row class="my-1">
                          <b-col lg="9" md="8">
                            <b-card
                              class="card-booking-profile-doomyoga"
                              :title="row.title"
                              :sub-title="row.duration"
                            ></b-card>
                          </b-col>
                          <b-col
                            lg="3"
                            md="4"
                            class="d-flex align-items-center"
                          >
                            <b-button
                              variant="cutomer-primary-outline"
                              class="
                                w-100
                                btn-bumblebee btn-doomyoga btn-doom-yoga-play
                              "
                              @click="clickCancelBooking(row.id)"
                              >Cancel</b-button
                            >
                          </b-col>
                        </b-row>
                      </template>
                      <template #noDataFound>
                        <div class="pt-2">
                          <p
                            class="
                              text-center
                              datasetNoFoundP
                              noDataFoundProfileDY
                              mb-0
                            "
                          >
                            You have nothing booked yet
                          </p>
                        </div>
                      </template>
                    </dataset-item>
                  </b-col>
                </b-row>
                <!-- <div
                    class="
                      d-flex
                      flex-md-row flex-column
                      justify-content-between
                      align-items-center
                    "
                  >
                    <dataset-info class="mb-2 mb-md-0 datasetInfo" />
                    <dataset-pager />
                  </div> -->
              </dataset>
              <!-- end booked classes -->
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
import MediaSimpleCardList from "@/components/media_components/MediaSimpleCardList.vue";
import SimpleMediaCard from "@/components/media_components/SimpleMediaCard.vue";
import {
  filterList,
  clone,
  isoDateToEuroDate,
  searchAsEuroDate,
} from "vue-dataset/docs/.vuepress/utilities";
import { debounce, fieldFilter, findAny } from "vue-dataset/src/helpers";

export default {
  name: "DoOmYogaCustomerProfileIndex",
  components: { MediaSimpleCardList, SimpleMediaCard },
  data() {
    return {
      login_user: window.localStorage.getItem("user"),
      user_name: "",
      avatar_text: "",
      entries: 100,
      profile_img: "",
      previously_played_list: [
        {
          id: 1,
          title: " Mental Training",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 2,
          title: " Mental Training 2",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 1,
          title: " Mental Training",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
        {
          id: 2,
          title: " Mental Training 2",
          duration: "50 Min 30 sec",
          img_src:
            "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
        },
      ],

      booked_events: [
        { id: 1, title: "1-on-1 class", duration: "4:00 pm - 5:00 pm" },
        { id: 2, title: "1-on-1 class", duration: "4:00 pm - 5:00 pm" },
      ],
      settings_slick: {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        swipeToSlide: true,
        responsive: [
          //col-xl-2 col-lg-3 col-md-3 col-6
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 3,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 380,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      },
      //   profile_img:
      //     "https://images.unsplash.com/photo-1614925861087-aa06270091b3?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8OXx8YmxhY2slMjBhbmQlMjB3aGl0ZSUyMG5hdHVyZXxlbnwwfHwwfHw%3D&w=1000&q=80",
    };
  },

  created() {
    // this.innerLoop = this.loop.state;
    this.startWithInput = debounce((e) => {
      this.startsWith = e.target.value;
    }, 100);
  },
  mounted() {
    console.log(window.localStorage.getItem("user"));
    this.login_user = JSON.parse(window.localStorage.getItem("user"));
    this.user_name = this.login_user.name;
    this.avatar_text = this.login_user.first_name[0]+this.login_user.second_name[0]
    console.log(this.user_name);
  },
  updated() {},
  methods: {
    filterList,
    isoDateToEuroDate,
    searchAsEuroDate,
    // updateData() {
    //   const updatedList = clone(tracks).slice(5, 5);
    //   this.tracks = updatedList;
    // },
    startsWithFilter(value) {
      return (
        value === null ||
        value.toLowerCase().startsWith(this.startsWith.toLowerCase())
      );
    },
    searchTest(value, searchString, rowData) {
      console.log(value);
      console.log(searchString);
      console.log(rowData);
      console.log(searchString === value);
      return searchString === value;
    },
    fieldFilter,
    clickCancelBooking(id) {
      console.log("click cancel booking ", id);
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/customer/Profile/Index.vue